import { useQuery } from "@tanstack/react-query"

import { client } from "@/api"
import queryKeys from "@/api/queryKeys"

function useListEventTypes() {
  return useQuery({
    queryKey: queryKeys.events.types({}).queryKey,
    queryFn: () =>
      client.get(`/events/types`).then((response) => response.data),
  })
}
export default useListEventTypes
